import React from "react";

type ModalProps = {
    isOpen: boolean;
    message: string;
    isSuccess: boolean;
    onClose: () => void;
};

export default function Modal({ isOpen, message, isSuccess, onClose }: ModalProps) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-10 rounded shadow-lg">
                <h3 className={`text-lg font-bold ${isSuccess ? 'text-green-600' : 'text-red-700'}`}>
                    {isSuccess ? 'Success' : 'Error'}
                </h3>
                <p className="mt-5">{message}</p>
                <button onClick={onClose} className="w-full mt-5 px-4 py-2 bg-primary text-white rounded">
                    Close
                </button>
            </div>
        </div>
    );
}
